import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import ArticleCard from '@/components/base/ArticleCard';
import { articles, categories } from '@/mocks/articles';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();

  const category = categories.find((c) => c.slug === slug);
  const categoryArticles = articles.filter((a) => a.categorySlug === slug);

  const categoryName = category?.name || '未知分类';

  return (
    <>
      <Navbar />
      <main className="pt-20">
        <div className="w-full px-4 md:px-6 py-6">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: categoryName },
            ]}
          />

          <div className="mb-8">
            <div className="flex items-center gap-3 mb-2">
              {category && (
                <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center">
                  <i className={`${category.icon} text-lg text-primary-500`}></i>
                </div>
              )}
              <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                {categoryName}
              </h1>
            </div>
            <p className="text-sm text-foreground-500 ml-13">
              共 {categoryArticles.length} 篇爆料文章
            </p>
          </div>

          {categoryArticles.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-10">
              {categoryArticles.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-background-100 flex items-center justify-center">
                <i className="ri-emotion-sad-line text-2xl text-foreground-400"></i>
              </div>
              <p className="text-foreground-500">该分类暂无文章</p>
              <Link to="/" className="text-sm text-primary-500 hover:text-primary-600 mt-2 inline-block">
                返回首页
              </Link>
            </div>
          )}

          <div className="mb-10">
            <h3 className="text-lg font-heading font-bold text-foreground-900 mb-4">其他分类</h3>
            <div className="flex flex-wrap gap-3">
              {categories
                .filter((c) => c.slug !== slug)
                .map((c) => (
                  <Link
                    key={c.slug}
                    to={`/category/${c.slug}`}
                    className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-100 hover:bg-primary-100 text-sm text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className={`${c.icon} text-sm`}></i>
                    {c.name}
                  </Link>
                ))}
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}